import React from 'react';
import styled from 'styled-components';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from './componentes_generales/componentes_formulario/contenedores/';
import global_axios from '../funciones_globales/interaccionapi';
import { borrarDatosSesion, getItemDatosSesion } from '../funciones_globales/manejosesion';

const MensajeError = styled.h5`
    color: red;
    text-align: center;
    font-weight: 600;
`;

const Boton = styled.button`
    display: block;
    margin: auto;    
    font-size: 13px;
`;

const ContenedorCambioClave = styled.div`
    max-width: 100%;
    font-family: Verdana, Geneva, sans-serif;    
    margin-top: 50px;
`;

export default class CambioClave extends React.Component{  
    constructor(props){
        super(props);
        this.state = {
            username: getItemDatosSesion('usuario')!==undefined?getItemDatosSesion('usuario'):'',
            claveActual: '',
            claveNueva1: '',
            claveNueva2: '',
            msg_error: '',
            isVisibleClaves: false
        }
        this.submit = this.submit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    submit(e){
        e.preventDefault();

        const username = this.state.username;
        const claveActual = this.state.claveActual;
        const claveNueva1 = this.state.claveNueva1;
        const claveNueva2 = this.state.claveNueva2;
        
        if (username.toString().trim().length===0){
            this.setState({msg_error: 'Complete el campo Usuario'})
            return;
        }else{
            if (username.toString().trim().length> 10 ){
                this.setState({msg_error: 'El campo Usuario es incorrecto'});
                return;
            }
        }

        if(claveActual.toString().length===0){
            this.setState({msg_error: 'Complete el campo Contraseña Actual'})
            return;
        }

        if(claveNueva1.toString().length===0){
            this.setState({msg_error: 'Complete el campo Contraseña Nueva'})
            return;
        }

        if(claveNueva2.toString().length===0){
            this.setState({msg_error: 'Complete el campo Confirmar Contraseña Nueva'})
            return;
        }

        if(claveNueva1 !== claveNueva2){
            this.setState({msg_error: 'La nueva contraseña no es igual en los dos campos solicitados.'});
            return;
        }

        let expRegValidaClave = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{10,}/;
        if(!expRegValidaClave.test(claveNueva1)){
            this.setState({msg_error: 'La nueva contraseña debe contener 10 a 15 caracteres, al menos 1 dígito, un caracter en minúscula y uno en mayúscula.'});
            return;
        }

        this.setState({msg_error: ''});
        
        global_axios({
            method: 'POST',
            url: `/usuarios/${username}/claves`,
            data: {username, claveActual, claveNueva: claveNueva1}
        })
        .then(()=> {
            this.limpiar();
            borrarDatosSesion();
            alert('Su clave se actualizó correctamente.');
            this.props.history.push('/login');
        })
        .catch((error)=>{
            if (error.response){
                this.setState({msg_error: error.response.data.msg});
            }else{
                this.setState({msg_error: 'Existen problemas de comunicación con el servidor de Web API.'});
            }
        });
    }
    
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
    }

    limpiar(){
        this.setState({
            username: '',
            claveActual: '',
            claveNueva1: '',
            claveNueva2: '',
            msg_error: '',
            isVisibleClaves: false
        });
    }

    render(){
        return(
            <ContenedorCambioClave>
                <ContenedorForm porc_ancho={25}>
                    <HeaderForm>
                        <TituloForm>Cambio de Contraseña</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <Row margen_arriba={20}>
                            <ContainerCol className='col-sm-12'>
                                <form id='form_login' onSubmit={this.submit}>
                                    <div className='form-group'>
                                        <div className='input-group'>
                                            <span className='input-group-addon'><i className='fa fa-user'></i></span>
                                            <input
                                                name='username'
                                                type='text'
                                                placeholder='Usuario'
                                                className='form-control'
                                                autoComplete='off'
                                                onChange={this.handleInputChange}
                                                value={this.state.username}
                                                maxLength={10}
                                            />
                                        </div>
                                    </div>
                                    <div className='form-group'>
                                        <div className='input-group'>
                                            <span className='input-group-addon'><i className='fa fa-key'></i></span>
                                            <input
                                                name='claveActual'
                                                type={this.state.isVisibleClaves?'text':'password'}
                                                placeholder='Contraseña actual'
                                                className='form-control'
                                                autoComplete='off'
                                                onChange={this.handleInputChange}
                                                value={this.state.claveActual}
                                                maxLength={15}
                                            />
                                        </div>
                                    </div>
                                    <div className='form-group'>
                                        <div className='input-group'>
                                            <span className='input-group-addon'><i className='fa fa-key'></i></span>
                                            <input
                                                name='claveNueva1'
                                                type={this.state.isVisibleClaves?'text':'password'}
                                                placeholder='Contraseña nueva'
                                                className='form-control'
                                                autoComplete='off'
                                                onChange={this.handleInputChange}
                                                value={this.state.claveNueva1}
                                                maxLength={15}
                                            />
                                        </div>
                                    </div>
                                    <div className='form-group'>
                                        <div className='input-group'>
                                            <span className='input-group-addon'><i className='fa fa-key'></i></span>
                                            <input
                                                name='claveNueva2'
                                                type={this.state.isVisibleClaves?'text':'password'}
                                                placeholder='Confirmar contraseña nueva'
                                                className='form-control'
                                                autoComplete='off'
                                                onChange={this.handleInputChange}
                                                value={this.state.claveNueva2}
                                                maxLength={15}
                                            />
                                        </div>
                                    </div>
                                    <div className='checkbox'>
                                        <label><input name='isVisibleClaves' type='checkbox' checked={this.state.isVisibleClaves}
                                            onChange={this.handleInputChange}/>
                                        Ver Contraseñas</label>
                                    </div>
                                    <Boton className='btn btn-primary pull-center' type='submit'>
                                        <i className='fa fa-save fa-lg'/> Cambiar contraseña</Boton>
                                </form>
                                <MensajeError>{this.state.msg_error}</MensajeError>                           
                            </ContainerCol>
                        </Row>
                    </CuerpoForm>
                </ContenedorForm>
            </ContenedorCambioClave>
        )
    }
}